import { createTypedOutlet } from "src/router";

import type { Sync } from "./utils/types";

export type SyncOutletContext = {
  sync: Sync;
  onRefetch: () => void;
};

const {
  OutletProvider: SyncOutlet,
  useContext: useSyncOutletContext,
  useOptionalContext: useSyncOutletContextIfAvailable,
} = createTypedOutlet<SyncOutletContext>("Sync");

export { SyncOutlet, useSyncOutletContext, useSyncOutletContextIfAvailable };
